export default __webpack_public_path__ + "static/media/landlords-room.c8501f29.webp";